module.exports = __webpack_public_path__ + "img/dots-2.86b284d9.svg";